import CoreCompanyDetails from './CompanyDetails/CoreCompanyDetails';
import PortalInformation from './CompanyDetails/PortalInformationForm';
import { useState } from 'react';
import { Box, styled } from '@mui/material';
import { Vehicle } from 'further-types/lp/vehicle';
import VerticalTabs from 'components/new/VerticalTabs';
import { match } from 'ts-pattern';
import { HoldingsTab } from './types';

const StyledBox = styled(Box)(() => ({
  width: '400px',
}));

type Props = {
  selectedVehicle: Vehicle;
};

const CompanyForm: React.FC<Props> = ({ selectedVehicle }) => {
  const [currentTab, setCurrentTab] = useState<HoldingsTab>(
    HoldingsTab.Details,
  );

  return (
    <VerticalTabs
      selectedTab={currentTab}
      tabs={[
        {
          label: 'Holding details',
          id: HoldingsTab.Details,
        },
        {
          label: 'Portal information',
          id: HoldingsTab.PortalInformation,
        },
      ]}
      renderContent={(tab) => (
        <StyledBox>
          {match(tab)
            .with(HoldingsTab.Details, () => (
              <CoreCompanyDetails selectedVehicle={selectedVehicle} />
            ))
            .with(HoldingsTab.PortalInformation, () => <PortalInformation />)
            .exhaustive()}
        </StyledBox>
      )}
      onTabChange={setCurrentTab}
    />
  );
};

export default CompanyForm;
